/* DSV weekend links: progressive enhancement for asynchronously inserted links. */
(() => {
  'use strict';
  const node = document.getElementById('dsv-weekend-link-config');
  if (!node) return;
  let config;
  try { config = JSON.parse(node.textContent); } catch (_) { return; }
  if (!config.target || !Array.isArray(config.paths)) return;
  const paths = new Set(config.paths);
  const hosts = new Set([location.hostname, 'despelletjesvrienden.nl',
    'www.despelletjesvrienden.nl', config.shopDomain, config.permanentDomain].filter(Boolean));
  let target;
  try { target = new URL(config.target, location.origin); } catch (_) { return; }
  if (target.origin !== location.origin || !/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?pages\/[^/]+\/?$/i.test(target.pathname)) return;
  function update(anchor) {
    if (!anchor.matches('a[href]') || anchor.closest('[data-dsv-weekend-keep-product-link], [data-dsv-weekend-booking]')) return;
    if (config.bookingPage && anchor.closest('main')) return;
    const raw = anchor.getAttribute('href');
    if (!raw || raw === config.target || /^(?:#|mailto:|tel:|javascript:)/i.test(raw)) return;
    let url;
    try { url = new URL(raw, location.href); } catch (_) { return; }
    if (!['https:', 'http:'].includes(url.protocol) || !hosts.has(url.hostname) || url.username || url.password) return;
    let path = url.pathname.replace(/\/+$/, '').replace(/^\/[a-z]{2}(?:-[a-z]{2})?(?=\/(?:products|pages|collections)\/)/i, '');
    path = path.replace(/^\/collections\/[^/]+(?=\/products\/)/, '');
    if (paths.has(path)) anchor.setAttribute('href', config.target);
  }
  function scan(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.nodeType === 1) update(root);
    root.querySelectorAll('a[href]').forEach(update);
  }
  scan(document);
  new MutationObserver(records => {
    for (const record of records) {
      if (record.type === 'attributes') update(record.target);
      else record.addedNodes.forEach(scan);
    }
  }).observe(document.body, {childList: true, subtree: true, attributes: true, attributeFilter: ['href']});
})();
